import React, { useMemo } from 'react';
import { BasicInfoCollapse } from '../../../../../../../components';
import { Typography } from '../../../../../../../components';
import { SingleDiskInfo } from '../../DetailsAndSettings/SingleDiskInfo';

const { Text } = Typography;

export const StorageInformation = ({ record }) => {
    return (
        <BasicInfoCollapse title="Storage Information" greyHeader={true}>
            <Text>Mounts ({record?.storage_disks?.length || 0})</Text>
            {record?.storage_disks?.map((disk, index) => (
                <SingleDiskInfo key={index} index={index} record={record} />
            ))}
        </BasicInfoCollapse>
    );
};
